import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "bt-icon bt-icon--m" }
const _hoisted_3 = { class: "flex-grow-1 ml-3" }
const _hoisted_4 = { class: "room-objects__actions d-flex align-items-center" }
const _hoisted_5 = { class: "rows-container" }
const _hoisted_6 = { class: "list-unstyled mb-0" }
const _hoisted_7 = { class: "bt-icon bt-icon--m" }
const _hoisted_8 = { class: "ml-3" }
const _hoisted_9 = { class: "bt-icon bt-icon--xs" }
const _hoisted_10 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock(_component_ElScrollbar, null, {
    default: _withCtx(() => [
      _createVNode("div", {
        class: ["room-objects mb-2", { 'is--expanded': _ctx.isExpanded }]
      }, [
        _createVNode(_component_Card, null, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode("span", _hoisted_2, [
                _createVNode(_component_InlineSvgScoped, {
                  src: 
                                    require(`@/assets/images/icons/icon-command.svg`)
                                
                }, null, 8, ["src"])
              ]),
              _createVNode("div", _hoisted_3, _toDisplayString(_ctx.aggregateCommand.name), 1),
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_Button, {
                  class: "p-button-text ml-2 expand-btn",
                  onClick: _ctx.toggleExpand
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InlineSvgScoped, {
                      src: 
                                        require(`@/assets/images/icons/icon-arrows-down.svg`)
                                    
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }),
        _withDirectives(_createVNode("div", _hoisted_5, [
          _createVNode("ul", _hoisted_6, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.aggregateCommand.subItemList, (subItem) => {
              return (_openBlock(), _createBlock("li", {
                class: "object-row d-flex align-items-center",
                key: subItem.linkableObjectId
              }, [
                _createVNode("span", _hoisted_7, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: 
                                    require(`@/assets/images/icons/${_ctx.getSceneObjectIconFromType(
                                        subItem.sceneObjectType, subItem.energyObjectType
                                    )}.svg`)
                                ,
                    "aria-label": "icon-blueprint"
                  }, null, 8, ["src"])
                ]),
                _createVNode("span", _hoisted_8, _toDisplayString(subItem.name), 1),
                _createVNode(_component_Button, {
                  class: "ml-auto p-button-rounded p-button-outlined",
                  onClick: ($event: any) => (_ctx.handleAddObject(subItem))
                }, {
                  default: _withCtx(() => [
                    _createVNode("span", _hoisted_9, [
                      _createVNode(_component_InlineSvgScoped, {
                        src: 
                                        require(`@/assets/images/icons/icon-plus-outline.svg`)
                                    ,
                        "aria-label": "icon-grid"
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("AppResource.Add")), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128))
          ])
        ], 512), [
          [_vShow, _ctx.isExpanded]
        ])
      ], 2)
    ]),
    _: 1
  }))
}